// eslint-disable-next-line no-warning-comments
// TODO: Use this enum to replace the isCustomStoreApp config option in shopify-api-js
var AppDistribution;
(function (AppDistribution) {
    AppDistribution["AppStore"] = "app_store";
    AppDistribution["SingleMerchant"] = "single_merchant";
    AppDistribution["ShopifyAdmin"] = "shopify_admin";
})(AppDistribution || (AppDistribution = {}));
var LoginErrorType;
(function (LoginErrorType) {
    LoginErrorType["MissingShop"] = "MISSING_SHOP";
    LoginErrorType["InvalidShop"] = "INVALID_SHOP";
})(LoginErrorType || (LoginErrorType = {}));

export { AppDistribution, LoginErrorType };
//# sourceMappingURL=types.mjs.map
